import { render, staticRenderFns } from "./PartnersSection.vue?vue&type=template&id=5be46338&scoped=true"
import script from "./PartnersSection.vue?vue&type=script&lang=js"
export * from "./PartnersSection.vue?vue&type=script&lang=js"
import style0 from "./PartnersSection.vue?vue&type=style&index=0&id=5be46338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be46338",
  null
  
)

export default component.exports